module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm8-5573344e86c61461f8f4d5bbd2d83c12.jpg";